import { Link } from 'react-router-dom';
import { Tv, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
    return (
        <>
            <footer className="bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800 text-white border-t border-gray-800/50">
                <div className="max-w-6xl mx-auto px-6">

                    {/* Main Row */}
                    <div className="flex flex-col lg:flex-row justify-between gap-12 py-16">

                        {/* Left Column - Brand (1/4 width) */}
                        <div className="lg:w-1/3">
                            <div className="flex items-center gap-3 mb-4">
                                {/* <Tv className="h-7 w-7 text-indigo-400" /> */}
                                 <img src='./images/ctv_logo_white.png' className="h-12 w-12 text-black"/>
                                <span className="text-xl font-bold mt-[9px]">SocialTV</span>
                            </div>
                            <p className="text-gray-400 text-sm leading-relaxed mb-6">
                                Transform your social media posts into stunning 4K TV ads. The simplest way to reach audiences on connected TV.
                            </p>
                            <div className="flex gap-3">
                                <button className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-all group">
                                    <Twitter size={16} className="text-gray-400 group-hover:text-white" />
                                </button>
                                <button className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-all group">
                                    <Instagram size={16} className="text-gray-400 group-hover:text-white" />
                                </button>
                                <button className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-all group">
                                    <Linkedin size={16} className="text-gray-400 group-hover:text-white" />
                                </button>
                                <button className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-all group">
                                    <Youtube size={16} className="text-gray-400 group-hover:text-white" />
                                </button>
                            </div>
                        </div>

                        {/* Right Columns - Three Grids (3/4 width) */}
                        <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-3 gap-8 lg:pl-12">

                            {/* Grid 1 - Company */}
                            <div>
                                <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider mb-5">Company</h4>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Home
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                About Us
                                            </span>
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Blog
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Careers
                                            </span>
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>

                            {/* Grid 2 - Support */}
                            <div>
                                <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider mb-5">Resources</h4>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/support" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Support
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Contact Us
                                            </span>
                                        </Link>
                                    </li>
                                    {/* <li>
                            <Link to="/faq" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                              <span className="flex items-center gap-2">
                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                FAQ
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/status" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                              <span className="flex items-center gap-2">
                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                System Status
                              </span>
                            </Link>
                          </li> */}
                                </ul>
                            </div>

                            {/* Grid 3 - Legal */}
                            <div>
                                <h4 className="text-xs font-semibold text-gray-300 uppercase tracking-wider mb-5">Legal & Compliance</h4>
                                <ul className="space-y-3">
                                    <li>
                                        <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Privacy Policy
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                                            <span className="flex items-center gap-2">
                                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                                Terms
                                            </span>
                                        </Link>
                                    </li>
                                    {/* <li>
                            <Link to="/cookies" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                              <span className="flex items-center gap-2">
                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                Cookie Policy
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="/security" className="text-gray-400 hover:text-white text-sm transition-all duration-300 hover:translate-x-1 inline-block group">
                              <span className="flex items-center gap-2">
                                <span className="w-0 group-hover:w-2 h-0.5 bg-indigo-400 transition-all duration-300"></span>
                                Security
                              </span>
                            </Link>
                          </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Bar with Trust Indicators */}
                    <div className="border-t border-gray-800 py-6 text-center text-gray-400 text-sm">
                        © 2026  SocialTV. All rights reserved.
                    </div>
                </div>
            </footer>

        </>
    );
};

export default Footer;